import { useContext } from 'react';
import { TranslationContext } from '../../contexts/TranslationContext';
import translations from './translations.json';
import amTranslations from './amTranslations.json';

export default function useTranslation() {
  const { currentLanguage, configInfo, translatedNotifications } = useContext(TranslationContext);

  const currentLang = currentLanguage?.toLowerCase();

  const isGeorgian = configInfo?.countryCode === 'GE';

  const translationsJson = isGeorgian ? translations : {
    en: {
      ...translations.en,
      ...amTranslations.en,
    },
    ru: amTranslations.ru,
    am: amTranslations.am,
  };

  const trans = (text) => translationsJson[currentLang]?.[text] ?? text;
  const upperTrans = (text) => {
    (translationsJson[currentLang]?.[text] ?? text).toLocaleUpperCase();
  };

  const getDateLocale = () => {
    if (configInfo?.countryCode === 'GE') {
      return currentLanguage;
    }
    return currentLanguage === 'en' ? 'en' : 'am-hy';
  };

  const transNotification = (text) => translatedNotifications?.[text]?.[currentLanguage]
    ?? translatedNotifications?.[text]?.ka ?? '';

  return {
    trans,
    upperTrans,
    currentLanguage,
    configInfo,
    dateLocale: getDateLocale(),
    transNotification,
  };
}
